import React from 'react';
import { isNotEmpty } from '../../../lib/ep';

const TokenIcon = ({ token, ...props }) => {
	const icon = props?.icon ?? false;

	if(icon === false && !isNotEmpty(token, 'full_image')) return null;

	if(icon) {
		return (
			<span class={`token_img is_icon ${icon}`} />
		)
	}

	return (
		<span class="token_img">
			<img src={token.full_image} height='100%' alt={token.title} />
		</span>
	)
};

export default TokenIcon;